import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ApartmentsInfoItem,
  ApartmentsInfoTitle,
  ApartmentsInfoValue
} from './styled';
import { Apartment } from '../../../graphql/graphql';

interface ApartmentInfoProps {
  deadline?: string | null;
  priceMin?: number | null;
  currency?: string;
  apartments?: Apartment[] | null;
  hasBillOfSale?: boolean;
}

export const ApartmentInfo: React.FC<ApartmentInfoProps> = ({
  apartments,
  priceMin,
  currency,
  deadline,
  hasBillOfSale
}) => {
  const { t } = useTranslation();

  const min =
    !!apartments?.length && Math.min(...apartments?.map(item => item.area));
  const max =
    !!apartments?.length && Math.max(...apartments?.map(item => item.area));

  const infoItems = useMemo(
    () => [
      {
        id: 'area',
        label: t('residences.area'),
        value: t('residences.from_to_area', { min, max }),
        isShown: min && max
      },
      {
        id: 'price',
        label: t('residences.price'),
        value: t('residences.priceMin', { priceMin, currency }),
        isShown: priceMin
      },
      {
        id: 'deadline',
        label: t('residences.deadline'),
        value: deadline,
        isShown: deadline
      },
      {
        id: 'billOfSale',
        label: t('residences.billOfSale'),
        value: t('residences.hasBillOfSale'),
        isShown: hasBillOfSale
      }
    ],
    [min, max, priceMin, currency, deadline, hasBillOfSale, t]
  );

  return infoItems.map(({ id, label, value, isShown }) => {
    if (!isShown) return null;
    return (
      <ApartmentsInfoItem key={id}>
        <ApartmentsInfoTitle tag="body_1">{label}</ApartmentsInfoTitle>
        <ApartmentsInfoValue tag="title_4_new">{value}</ApartmentsInfoValue>
      </ApartmentsInfoItem>
    );
  });
};
